export default function Entities() {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Entities</h1>
      <p className="text-gray-600">Browse and manage data entities</p>
    </div>
  );
}

